/**
 * Base prompt fallback. The canonical FLOW_WEAVER_SYSTEM_PROMPT lives inside
 * `AiAssistantDialog.tsx` (rad 82–281) and is passed into buildSystemPrompt
 * as `basePrompt`. This file exists so golden-file tests have a deterministic
 * fallback without importing the UI component.
 */
export const FALLBACK_BASE_PROMPT = `You are the Flow Weaver AI assistant.
You help users build visual workflows made of blocks, connectors, groups and layers.
Always stay within the scope of Flow Weaver: do not answer unrelated questions.`;
